import axios from "axios";
import qs from "qs";
import { redirectLogin, UserModule } from "@/store/modules/user";
import { getSign, getSignJson } from "@/utils/sign";
import { Message, MessageBox } from "element-ui";
import { decodeStr } from '@/utils/common';
const service = axios.create({
    timeout: 60000,
    headers: {
        post: {
            "Content-Type": "application/x-www-form-urlencoded;",
            "Cache-Control": "no-cache",
        },
    },
});
/**
 * 以下五种请求方法为遗留代码迁移 需要哪种自行斟酌
 */
service.getByQuery = (url) => {
    const map = {};
    const query = url.split("?")[1];
    if (query) {
        query.split("&").forEach((item) => {
            item.replace(/(.*)=(.*)/, (all, key, value) => {
                map[key] = decodeURIComponent(value); // 解码回原来的字符，因为后端校验签名时用解码后的
                return all;
            });
        });
    }
    const { sign, timestamp } = getSign(map);
    return service.get(url, {
        headers: {
            sign,
            timestamp,
        },
    });
};
service.getByParams = (url, params) => {
    let _url = url;
    if (Object.keys(params).length !== 0) {
        _url = `${url}?${qs.stringify(params)}`;
    }
    const { sign, timestamp } = getSign(params);
    return service.get(_url, {
        headers: {
            sign,
            timestamp,
        },
    });
};
service.postByQs = (url, data) => {
    const { sign, timestamp } = getSign(data);
    return service.post(url, qs.stringify(data), {
        headers: {
            sign,
            timestamp,
        },
    });
};
service.postByJson = (url, data, headers = {}) => {
    const { sign, timestamp } = getSignJson(data);
    return service.post(url, data, {
        headers: {
            "Content-Type": "application/json",
            sign,
            timestamp,
            ...headers,
        },
    });
};
service.postByForm = (url, data, header) => {
    const { sign, timestamp } = getSign(data);
    let _data = data;
    if (!(_data instanceof FormData)) {
        _data = new FormData();
        Object.keys(data).map(item => {
            _data.append(item, data[item]);
        });
    }
    return service.post(url, _data, {
        headers: {
            "Content-Type": false,
            sign,
            timestamp,
            ...header,
        },
    });
};
service.getExportFile = function (url) {
    let map = {};
    let datas = url.split("?")[1];
    if (datas) {
        datas.split("&").forEach(i => {
            i.replace(/(.*)=(.*)/, (all, key, value) => {
                map[key] = decodeStr(value); // 解码回原来的字符，因为后端校验签名时用解码后的
                return all;
            });
        });
    }
    const { sign, timestamp } = getSignJson(map);
    return service.get(url, {
        responseType: 'blob',
        withCredentials: true,
        headers: {
            "Cache-Control": "no-cache",
            sign: sign,
            timestamp: timestamp
        }
    });
};
service.postExportFile = function (url, data) {
    const { sign, timestamp } = getSignJson(data);
    return service.post(url, data, {
        responseType: 'blob',
        withCredentials: true,
        headers: {
            "Cache-Control": "no-cache",
            sign: sign,
            timestamp: timestamp
        }
    });
};
// 请求拦截器
service.interceptors.request.use((config) => {
    // 为每个请求添加token信息
    if (UserModule.token) {
        config.headers.token = UserModule.token;
    }
    if (UserModule.email) {
        config.headers.email = UserModule.email;
    }
    if (UserModule.ssoId) {
        config.headers.ssoUserId = UserModule.ssoId;
    }
    if (UserModule.email) {
        config.headers.email = UserModule.email;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
// 响应拦截器
service.interceptors.response.use((res) => {
    if (res.data.code == 501) {
        // 优先处理未授权的情况
        MessageBox.alert("您的登录信息已失效，请重新登录", "提示", {
            type: "info",
            // 此处没有cancel按钮
            callback: () => {
                UserModule.clearAuth();
                redirectLogin();
            },
        });
        return Promise.reject();
    }
    else if (res.data.code == 200) {
        return Promise.resolve(res);
    }
    else if (res.data.status != 200) {
        // 统一alert异常情况
        Message.error(res.data.msg || '服务器异常');
        return Promise.reject(res.data.msg);
    }
    // API成功返回即视为请求成功 resolve整个响应体以便于需要额外处理的场景
    return Promise.resolve(res);
}, (err) => {
    Message.error('服务器异常');
    return Promise.reject(err);
});
export default service;
